import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Public/Home'
import Page from '@/views/Public/Page'
import Login from '@/views/Public/Login'
import About from '@/views/Public/About'
import Terms from '@/views/Public/Terms'
import Privacy from '@/views/Public/Privacy'
import store from '../store'

import Viewer from "@/views/Public/Viewer";
import Applicant from "@/views/Public/Applicant";
import ApplicantView from "@/views/Public/ApplicantView";
import LibraryView from "@/views/Public/Library";
import Template from "@/views/Public/Template";


//User
import Subscription from "@/views/User/Subscription";
import Portals from "@/views/User/Portals";
import Portal from "@/views/User/Portal";
import Billing from "@/views/User/Billing";
import Editing from "@/views/User/Editing"

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/viewer-link/:uid',
    name: 'Viewer',
    component: Viewer
  }, {
    path: '/template/:id',
    name: 'Template',
    component: Template
  }, {
    path: '/applicant-link/:uid',
    name: 'Applicant',
    component: Applicant
  }, {
    path: '/applicant-view/:uid',
    name: 'ApplicantView',
    component: ApplicantView
  },
  {
    path: '/library/:uid',
    name: 'LibraryView',
    component: LibraryView
  }, {
    path: '/terms',
    name: 'Terms',
    component: Terms
  },

  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Login
  },
  {
    path: '/subscription',
    name: 'Subscription',
    meta: {
      requiresAuth: true
    },
    component: Subscription
  },
  {
    path: '/billing',
    name: 'Subscription',
    meta: {
      requiresAuth: true
    },
    component: Billing
  },
  {
    path: '/edit-services/:id',
    name: 'Editing',
    meta: {
      requiresAuth: true
    },
    component: Editing
  },
  {
    path: '/portals',
    name: 'Portals',
    meta: {
      requiresAuth: true,
      requiresMembership: true,
    },
    component: Portals
  },
  {
    path: '/portals/:id',
    name: 'Portal',
    meta: {
      requiresAuth: true,
      requiresMembership: true,
    },
    component: Portal
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import( /* webpackChunkName: "Admin" */ '@/views/Admin'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
    children: [{
      path: "users",
      component: () => import( /* webpackChunkName: "AdminUsers" */ '@/views/Admin/Users'),
      name: "AdminUsers"
    }, {
      path: "users/:id",
      component: () => import( /* webpackChunkName: "AdminUser" */ '@/views/Admin/User'),
      name: "AdminUser"
    }, {
      path: "content/general",
      component: () => import( /* webpackChunkName: "AdminGeneral" */ '@/views/Admin/Content/General'),
      name: "AdminGeneral"
    }, {
      path: "content/about",
      component: () => import( /* webpackChunkName: "AdminAbout" */ '@/views/Admin/Content/About'),
      name: "AdminAbout"
    }, {
      path: "content/payments",
      component: () => import( /* webpackChunkName: "AdminPayments" */ '@/views/Admin/Content/Payments'),
      name: "AdminPayments"
    }, {
      path: "content/memberships",
      component: () => import( /* webpackChunkName: "AdminMemberships" */ '@/views/Admin/Content/Memberships'),
      name: "AdminMemberships"
    }, {
      path: "notifications/email",
      component: () => import( /* webpackChunkName: "AdminEmailNotifications" */ '@/views/Admin/EmailNotifications'),
      name: "AdminEmailNotifications"
    }, {
      path: "notifications/website",
      component: () => import( /* webpackChunkName: "AdminWebsiteNotifications" */ '@/views/Admin/WebsiteNotifications'),
      name: "AdminWebsiteNotifications"
    }, {
      path: "content/pages",
      component: () => import( /* webpackChunkName: "AdminPages" */ '@/views/Admin/Content/Pages'),
      name: "AdminPages"
    }, {
      path: "content/pages/:id",
      component: () => import( /* webpackChunkName: "AdminPage" */ '@/views/Admin/Content/Page'),
      name: "AdminPage"
    }, {
      path: "portals",
      component: () => import( /* webpackChunkName: "AdminPortals" */ '@/views/Admin/Portals'),
      name: "AdminPortals"
    }, {
      path: "portals/:id",
      component: () => import( /* webpackChunkName: "AdminPortal" */ '@/views/Admin/Portal'),
      name: "AdminPortal"
    }, {
      path: "templates",
      component: () => import( /* webpackChunkName: "AdminTemplates" */ '@/views/Admin/Templates'),
      name: "AdminTemplates"
    }, {
      path: "editing/services",
      component: () => import( /* webpackChunkName: "AdminEditingServices" */ '@/views/Admin/Editing/Services'),
      name: "AdminEditingServices"
    }, {
      path: "editing/requests",
      component: () => import( /* webpackChunkName: "AdminEditingRequests" */ '@/views/Admin/Editing/Requests'),
      name: "AdminEditingRequests"
    }],
  },
  {
    path: '/:slug',
    name: 'Page',
    component: Page
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['isLoggedIn']) {
      return next()
    }
    console.log("Login required to", to)
    store.commit('set_continue', to);
    next('/login')
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    console.log("Admin login required")
    if (!store.getters['isLoggedIn']) {
      store.commit('set_continue', to);
      store.commit("logout");
      next('/login')
    }
    if (store.getters['isAdmin']) {
      return next()
    } else {
      next("/")
    }
  } else {
    next()
  }
})




export default router